import { cn } from '../../lib/cn';
import type { CommandCenterScore } from '../../enterpriseacceptance/framework';

type Props = { scores?: CommandCenterScore[] };

export function AlphaCommandCenterPanel({ scores = [] }: Props) {
  return (
    <div className="grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
      {scores.map((s) => (
        <div key={s.label} className="rounded-lg border border-slate-200 bg-white p-3 dark:border-slate-700 dark:bg-slate-900">
          <p className="text-xs text-slate-500">{s.label}</p>
          <p className="mt-1 text-lg font-semibold text-slate-900 dark:text-slate-100">{s.value}</p>
          <p className={cn('mt-0.5 text-xs font-medium', s.positive ? 'text-success-600' : 'text-error-600')}>
            {s.change}
          </p>
        </div>
      ))}
    </div>
  );
}
